export const PERMISSIONS = {
  MENU_NO_SALE: "NO",
  MENU_VENDOR_PAYOUT: "VE",
  MENU_CASH_DROP: "CA",
  MENU_PAY_IN: "PI",
  MENU_RECEIPTS: "RE",
  MENU_CANCEL_REFUND_PAYMENT: "CF",
  MENU_QUICKADD: "QU",
  MENU_CHANGE_PRICE: "CH",
  MENU_DISCOUNT: "DI",
  MENU_OTD_PRICE: "OT",
  MENU_CASH_PAYMENT: "CT",
  MENU_CREDIT_DEBIT_PAYMENT: "CR",
  MENU_CLOSE_OPEN_SHIFT: "CL",
  MENU_ACCESS_EMPLOYEES: "AE",
  MENU_MANAGE_EMPLOYEES: "ME",
  MENU_TIMESHEET: "TI",
  MENU_DELETE_EMPLOYEES: "DE",
  MENU_EDIT_ITEMS: "ED",
  MENU_ADD_ITEMS: "AD",
  MENU_DISABLE_ITEM: "DS",
  MENU_DELETE_ITEMS: "RI",
  MENU_MASS_INVENTORY_UPDATE: "MIU",
  MENU_EDIT_CATEGORIES: "UC",
  MENU_ADD_CATEGORIES: "CC",
  MENU_DISABLE_CATEGORIES: "PC",
  MENU_DELETE_CATEGORIES: "RC",
  MENU_ADD_VENDOR: "CV",
  MENU_EDIT_VENDOR: "UV",
  MENU_DISABLE_VENDOR: "PV",
  MENU_DELETE_VENDOR: "DV",
  MENU_ADD_COUPON: "AO",
  MENU_EDIT_COUPON: "UO",
  MENU_DELETE_COUPON: "RO",
  MENU_ADD_CUSTOMER: "AU",
  MENU_EDIT_CUSTOMER: "UU",
  MENU_DISABLE_CUSTOMER: "PU",
  MENU_DELETE_CUSTOMER: "RU",
  MENU_ADD_POINTS_CUSTOMER: "IP",
  MENU_REMOVE_POINTS_CUSTOMER: "DP",
  MENU_STORE_INFO: "ST",
  MENU_RECEIPT_TEMPLATE: "PT",
  MENU_REPORTING_TIME: "SE",
  MENU_REGISTER_SETTINGS: "PS",
  MENU_HARDWARE: "HA",
  MENU_SYSTEM_ACCESS: "SY",
  MENU_ALERTS: "AL",
  MENU_ACCESS_TAXES: "T",
  MENU_STORE_OPTIONS: "OP",
  MENU_DISPATCH_CENTER: "CD",
  MENU_COUPON: "C",
  MENU_ADD_POINTS: "IP",
  MENU_REMOVE_POINTS: "DP",
  MENU_QUICK_ADD: "QA",
  MENU_MORE: "MR",
  MENU_ONLINE_STORE_SETUP: "SC",
  MENU_ITEM_DISCOUNT: "ID",
  MENU_ADD_GIFT_CARD_BALANCE: "GB",
  MENU_REMOVE_GIFT_CARD_BALANCE: "RB",
  MENU_GIFT_CARD: "GC",
  MENU_ADD_REMOVE_TAX: "AT",
  MENU_FOOD_EBT: "FO",
  MENU_CASH_EBT: "CE",
  MENU_GIFT_CARD_ISSUE_REDEEM: "GI",
  MENU_CUSTOM_ITEM: "CI",
  MENU_CASH_BACK: "CB",
  MENU_VOID_ORDER: "VD",
  MENU_SHOW_COST: "SH",
  MENU_STATION_SETTING: "SS",
  MENU_CREATE_PO: "EO",
  MENU_VIEW_POS: "VI",
  MENU_EDIT_POS: "EP",
  MENU_RECEIVE_POS: "RP",
  MENU_VOID_POS: "VP",
  MENU_COPY_TO_STORE_POS: "CPOAS",
  // MENU_LOTTERY: "LT",
  MENU_LOTTERY: "L",

  MENU_21_PLUS_PRODUCT_MANUAL_VERIFICATION: "21",
  MENU_CHECK_ID_BYPASS: "CIB", // Android MENU_CHECK_ID_BYPASS: skip the ID scan, "Verify" straight away
  MENU_REGISTER_HOME_SCREEN: "RG",
  MENU_WEB_REGISTER: "WEBRG",
  MENU_ORDERS_HOME_SCREEN: "O",
  MENU_DASHBOARD: "D",
  MENU_CUSTOMERS_HOME_SCREEN: "CU",
  MENU_ATTENDANCE: "TC",
  MENU_REFUND: "RF",
  MENU_VIEW_CAMERA_FOOTAGE: "VFC", // Lumana order clips ("POS - Orders / View Camera Footage", 2026-10-19)
  MENU_LUMANA_CONNECTOR: "ALV", // Lumana connector settings ("Connectors / Access Lumana Video", 2026-10-19)
  MENU_ACCESS_REPORTS: "AR",
  MENU_SALES_REPORTS: "SA",
  MENU_INVENTORY_REPORTS: "IN",
  MENU_PAYMENT_REPORTS: "PA",
  MENU_REGISTER_ACTIVITY_REPORTS: "RA",
  MENU_REFUND_REPORTS: "RR",
  MENU_LOYALTY_REPORT: "LR",
  MENU_STORE_CREDIT_REPORTS: "SR",
  MENU_GIFT_CARD_REPORTS: "GR",
  MENU_TAX_REPORTS: "TR",
  MENU_LOCATION_REPORTS: "LO",
  MENU_ITEM_SOLD_REPORT: "ISR",
  MENU_CATEGORY_SOLD_REPORT: "CSR",
  MENU_PO_PRODUCTS_REPORT: "PPR", // "Reporting / PO Products Report" (2026-10-27)
  MENU_EMPLOYEE_HOURS_REPORTS: "EH",
  MENU_ACCESS_INVENTORY: "AI",
  MENU_MANAGE_CATEGORIES: "MC",
  MENU_MANAGE_PRODUCTS: "MP",
  MENU_BULK_PRODUCT_UPDATE: "BULKP",
  MENU_BULK_STORE_SETTINGS: "BULKS", // Store Settings > Bulk Update (employees, once opened up)
  MENU_MANAGE_ATTRIBUTES: "MA",
  MENU_MANAGE_BRANDS: "MB",
  MENU_MANAGE_TAGS: "MT",
  CREATE_TAG: "CRT",
  EDIT_TAG: "EDT",
  DELETE_TAG: "DET",
  MENU_AUDIT_LOG: "AUDIT",
  MENU_ACCESS_VENDORS: "AV",
  MENU_ACCESS_PURCHASE_ORDERS: "AP",
  MENU_INVENTORY_SETTINGS: "IS",
  MENU_ACCESS_COUPONS: "AC",
  MENU_UPDATE_ORDER_STATUS: "UP",
  MENU_CANCEL_ORDER: "CO",
  MENU_ACCESS_STORE_SETTINGS: "AS",
  MENU_PRINT_LABEL: "PL",
  MENU_DASHBOARD_GRAPH: "DG",
  MENU_ACCESS_STOCKTAKE: "AK",
  MENU_CREATE_STOCKTAKE: "CK",
  MENU_VIEW_STOCKTAKE: "VK",
  MENU_EDIT_STOCKTAKE: "EK",
  MENU_VOID_STOCKTAKE: "OK",
  MENU_DELETE_STOCKTAKE: "DST",
  MENU_ACCESS_INVENTORY_TRANSFER: "ITA",
  MENU_COMPOSITE_ITEMS: "COITM",
  MENU_CONTAINER_DEPOSIT: "CNTDT",
  MENU_CREATE_CANCEL_DRAFT_TRANSFER: "ITCCD",
  MENU_RECEIVE_TRANSFER: "ITR",
  /** Stock on Hand — employee codes */
  MENU_ACCESS_STOCK_ON_HAND: "ASOH",
  MENU_ADJUST_STOCK_ON_HAND: "ACSOH",
  MENU_WATCH_STOCK_ON_HAND: "WSOH",
  MENU_CUSTOMER_REPORTS: "CM",
  MENU_EMPLOYEE_REPORTS: "ER",
  MENU_ACCESS_LOYALTY_PROGRAM: "ALP",
  MENU_ACCESS_MIX_N_MATCH: "AMM",
  MENU_ADD_MIX_N_MATCH: "AM",
  MENU_EDIT_MIX_N_MATCH: "EM",
  MENU_DELETE_MIX_N_MATCH: "DM",
  MENU_EDIT_LOYALTY_PROGRAM: "EL",
  MENU_ADD_BONUS_POINTS_PROMOTIONS: "AB",
  MENU_EDIT_BONUS_POINTS_PROMOTIONS: "EB",
  MENU_DELETE_BONUS_POINTS_PROMOTIONS: "DB",
  MENU_MANAGE_STORE_ACCESS: "MSA",
  MENU_MANAGE_STORE_ADD_OR_EDIT: "AEE",
  MENU_MANAGE_STORE_ACCESS_PERMISSION: "APE",
  MENU_ADD_BOGO: "BA",
  MENU_EDIT_BOGO: "BE",
  MENU_DELETE_BOGO: "BD",
  MENU_ACCESS_BOGO: "ABG",
  MENU_ADD_LOTTERY: "LA",
  MENU_EDIT_LOTTERY: "LE",
  MENU_DELETE_LOTTERY: "LD",
  MENU_CUSTOMER_MERGE: "MM",
  HIDE_COST: "HC",
  ACCESS_AI: "AAI",
  EMPLOYEE_BULK_EDIT: "EBE",
  EMPLOYEE_MANAGE_ROLE: "EMR",
  EMPLOYEE_CREATE_ROLE: "ECR",
  EMPLOYEE_EDIT_ROLE: "EER",
  EMPLOYEE_DELETE_ROLE: "EDR",
  ADD_STORE_CREDIT: "ASC",
  REMOVE_STORE_CREDIT: "RSC",


  EMPLOYEE_DELETE_FOREVER: "EDF",
  EMPLOYEE_RESTORE: "ERE",
  ACCESS_CUSTOMER: "ACC",

  CANCEL_UBER_DELIVERY: "UD",
  BLOCKED: "BLOCKED", // Special permission code that no user will have - used to block routes

  ACCESS_BREAKS_AND_COMPLIANCE: "ABAC",
  ADD_BREAKS_AND_COMPLIANCE: "ADDBC",
  EDIT_BREAKS_AND_COMPLIANCE: "EDBC",

  ACCESS_PROMOTIONS: "APRO",

  /** CUFEE — Customer Feed: app posts, push notifications and the follower list. */
  ACCESS_CUSTOMER_FEED: "CUFEE",


  MENU_CREATE_BRANDS: "CBR",
  MENU_EDIT_BRANDS: "EBR",
  MENU_DELETE_BRANDS: "DBR",
  MENU_ACCESS_GROUP_MANAGEMENT: "AG",
  GROUP_MANAGEMENT_CREATE: "CG",
  GROUP_MANAGEMENT_EDIT: "EG",

};

/** AP — list, create, and sidebar menu. VI is only for PO detail routes. */
export const MENU_DROPDOWN_PERMISSIONS = {
  Employees: PERMISSIONS.MENU_ACCESS_EMPLOYEES,
  Inventory: PERMISSIONS.MENU_ACCESS_INVENTORY,
  Reporting: PERMISSIONS.MENU_ACCESS_REPORTS,
  "Store Settings": PERMISSIONS.MENU_ACCESS_STORE_SETTINGS,
  Promotions: PERMISSIONS.ACCESS_PROMOTIONS,
};

export const STORE_URLS_PERMISSIONS = {
  // Orders
  "/merchants/order": PERMISSIONS.MENU_ORDERS_HOME_SCREEN,
  "/merchants/order-new": PERMISSIONS.MENU_ORDERS_HOME_SCREEN,
  "/merchants/order-new/online-new": PERMISSIONS.MENU_ORDERS_HOME_SCREEN,
  // Customers
  "/merchants/customer": PERMISSIONS.ACCESS_CUSTOMER,
  "/merchants/customer/addCustomer": PERMISSIONS.MENU_ADD_CUSTOMER,
  "/merchants/customer/editCustomer": PERMISSIONS.MENU_EDIT_CUSTOMER,
  "/merchants/customer-management": PERMISSIONS.ACCESS_CUSTOMER,

  // ------------- promotions -------------
  // promotions/coupons
  "/merchants/promotions/coupons/add": PERMISSIONS.MENU_ADD_COUPON,
  "/merchants/promotions/coupons/edit-coupons/:couponsCode": PERMISSIONS.MENU_EDIT_COUPON,


  // promotions/bogo-pricing
  "/merchants/promotions/bogo-pricing": PERMISSIONS.MENU_ACCESS_BOGO,
  "/merchants/promotions/bogo-pricing/add": PERMISSIONS.MENU_ADD_BOGO,



  // promotions/loyalty-program
  "/merchants/loyalty-program": PERMISSIONS.MENU_ACCESS_LOYALTY_PROGRAM,



  // promotions/mix-and-match
  "/merchants/promotions/mix-and-match": PERMISSIONS.MENU_ACCESS_MIX_N_MATCH,
  "/merchants/promotions/mix-and-match/add": PERMISSIONS.MENU_ADD_MIX_N_MATCH,
  "/merchants/promotions/mix-and-match/update/:dealId": PERMISSIONS.MENU_EDIT_MIX_N_MATCH,
  // --------- promotions end ---------

  // --------- reporting ---------
  "/merchants/store-reporting/new-sale-report/:reportType": PERMISSIONS.MENU_SALES_REPORTS,
  // --------- reporting end ---------

  // --------- inventory ---------
  "/merchants/store-reporting/inventory-report/:reportType": PERMISSIONS.MENU_INVENTORY_REPORTS,
  // --------- inventory end ---------

  // --------- customer reports ---------
  "/merchants/store-reporting/customer-reports/:reportType": PERMISSIONS.MENU_CUSTOMER_REPORTS,
  // --------- customer reports end ---------

  // --------- employee reports ---------
  "/merchants/store-reporting/employee-reports/:reportType": PERMISSIONS.MENU_EMPLOYEE_REPORTS,
  "/merchants/store-reporting/employee-reports/employee-ratings-report/:employeeId": PERMISSIONS.MENU_EMPLOYEE_REPORTS,
  // --------- employee reports end ---------

  // --------- payment reports ---------
  "/merchants/store-reporting/payment-report": PERMISSIONS.MENU_PAYMENT_REPORTS,
  // --------- payment reports end ---------

  // --------- refund reports ---------
  "/merchants/store-reporting/refund-report-main/:reportType": PERMISSIONS.MENU_REFUND_REPORTS,
  // --------- refund reports end ---------

  // --------- register activity reports ---------
  "/merchants/store-reporting/register-activity/:reportType": PERMISSIONS.MENU_REGISTER_ACTIVITY_REPORTS,
  // --------- register activity reports end ---------

  // --------- loyalty points reports ---------
  "/merchants/store-reporting/detailed-loyalty-points-report": PERMISSIONS.MENU_LOYALTY_REPORT,
  // --------- loyalty points reports end ---------

  // --------- store credit reports ---------
  "/merchants/store-reporting/store-credit-report": PERMISSIONS.MENU_STORE_CREDIT_REPORTS,
  // --------- store credit reports end ---------

  // --------- gift card reports ---------
  "/merchants/store-reporting/gift-card-report": PERMISSIONS.MENU_GIFT_CARD_REPORTS,
  // --------- gift card reports end ---------

  // --------- taxes reports ---------
  "/merchants/store-reporting/new-taxes-report": PERMISSIONS.MENU_TAX_REPORTS,
  // --------- taxes reports end ---------

  // --------- location reports ---------
  "/merchants/store-reporting/location-report": PERMISSIONS.MENU_LOCATION_REPORTS,
  // --------- location reports end ---------

  // --------- item sold report (consolidated, multi-store) ---------
  // Own permission code (backend `permission` table rows id 332/333), no
  // longer piggybacking on MENU_LOCATION_REPORTS.
  "/merchants/store-reporting/item-sold-report": PERMISSIONS.MENU_ITEM_SOLD_REPORT,
  // --------- item sold report end ---------

  // --------- category sold report (consolidated, multi-store) ---------
  "/merchants/store-reporting/category-sold-report": PERMISSIONS.MENU_CATEGORY_SOLD_REPORT,
  // --------- category sold report end ---------

  // --------- po products report (consolidated, multi-store) ---------
  "/merchants/store-reporting/po-products-report": PERMISSIONS.MENU_PO_PRODUCTS_REPORT,
  // --------- po products report end ---------

  // Ask-AI
  "/merchants/ask-quickvee-ai": PERMISSIONS.ACCESS_AI,


  // ------------- inventory -------------
  // Inventory - products
  "/merchants/inventory/products": PERMISSIONS.MENU_MANAGE_PRODUCTS,
  "/merchants/inventory/products/add": PERMISSIONS.MENU_ADD_ITEMS,
  "/merchants/inventory/products/edit/:id": PERMISSIONS.MENU_EDIT_ITEMS,
  "/merchants/inventory/product-issues": PERMISSIONS.MENU_MANAGE_PRODUCTS,
  "/merchants/inventory/bulk-product-update": PERMISSIONS.MENU_BULK_PRODUCT_UPDATE,
  "/merchants/store-settings/bulk-update": PERMISSIONS.MENU_BULK_STORE_SETTINGS,
  "/merchants/inventory/transfer": PERMISSIONS.MENU_ACCESS_INVENTORY_TRANSFER,
  "/merchants/inventory/transfer/new-transfer": PERMISSIONS.MENU_ACCESS_INVENTORY_TRANSFER,
  "/merchants/inventory/composite-items": PERMISSIONS.MENU_COMPOSITE_ITEMS,
  "/merchants/inventory/composite-items/operations": PERMISSIONS.MENU_COMPOSITE_ITEMS,
  "/merchants/inventory/container-deposit": PERMISSIONS.MENU_CONTAINER_DEPOSIT,
  "/merchants/lumana-connect": PERMISSIONS.MENU_LUMANA_CONNECTOR,

  // Inventory - Categories
  "/merchants/inventory/category": PERMISSIONS.MENU_MANAGE_CATEGORIES,
  "/merchants/inventory/category/add": PERMISSIONS.MENU_ADD_CATEGORIES,
  "/merchants/inventory/category/edit-category/:categoryCode": PERMISSIONS.MENU_EDIT_CATEGORIES,

  // Inventory - New UI screens (same per-entity permission as the old ones)
  "/merchants/inventory/brands": PERMISSIONS.MENU_MANAGE_BRANDS,
  "/merchants/inventory/attributes": PERMISSIONS.MENU_MANAGE_ATTRIBUTES,
  "/merchants/inventory/tags": PERMISSIONS.MENU_MANAGE_TAGS,

  // Inventory - New Products UI (same per-action permissions as the old screens)
  "/merchants/inventory/new-products": PERMISSIONS.MENU_MANAGE_PRODUCTS,
  "/merchants/inventory/variants": PERMISSIONS.MENU_MANAGE_PRODUCTS,
  "/merchants/inventory/packaging": PERMISSIONS.MENU_MANAGE_PRODUCTS,
  "/merchants/inventory/new-products/add": PERMISSIONS.MENU_ADD_ITEMS,
  "/merchants/inventory/new-products/edit/:id": PERMISSIONS.MENU_EDIT_ITEMS,
  "/merchants/inventory/new-products/duplicate/:id": PERMISSIONS.MENU_ADD_ITEMS,

  // Inventory - Lottery
  "/merchants/inventory/lottery": PERMISSIONS.MENU_LOTTERY,
  "/merchants/inventory/lottery/add-lottery": PERMISSIONS.MENU_ADD_LOTTERY,
  "/merchants/inventory/lottery/update-lottery/:id": PERMISSIONS.MENU_EDIT_LOTTERY,

  // Stock on Hand — ASOH (access). Adjust/watch gated in-page (ACSOH / WSOH).
  "/merchants/stock-on-hand": PERMISSIONS.MENU_ACCESS_STOCK_ON_HAND,
  "/merchants/inventory/stock-on-hand": PERMISSIONS.MENU_ACCESS_STOCK_ON_HAND,

  // Audit log is its own sidebar item, not an Inventory submenu.
  "/merchants/audit-log": PERMISSIONS.MENU_AUDIT_LOG,

  //Purchase Orders — AP for module/list/create; VI for detail only
  "/merchants/purchase-order": PERMISSIONS.MENU_ACCESS_PURCHASE_ORDERS,
  "/merchants/purchase-order/add": PERMISSIONS.MENU_ACCESS_PURCHASE_ORDERS,
  "/merchants/purchase-order/:id": PERMISSIONS.MENU_VIEW_POS,

  //Stocktake
  "/merchants/stocktake/:pageNumber": PERMISSIONS.MENU_ACCESS_STOCKTAKE,
  "/merchants/stocktake/:pageNumber/void/:id": PERMISSIONS.MENU_ACCESS_STOCKTAKE,
  "/merchants/stocktake/:pageNumber/completed/:id": PERMISSIONS.MENU_ACCESS_STOCKTAKE,
  "/merchants/stocktake/:pageNumber/UpdateStocktake/:id": PERMISSIONS.MENU_EDIT_STOCKTAKE,
  "/merchants/stocktake/AddStocktake": PERMISSIONS.MENU_CREATE_STOCKTAKE,

  // New Stocktake UI
  "/merchants/stocktake-app": PERMISSIONS.MENU_ACCESS_STOCKTAKE,
  "/merchants/stocktake-app/:stocktakeId": PERMISSIONS.MENU_ACCESS_STOCKTAKE,


  // New Vendors (supplier master list UI)
  "/merchants/inventory/vendors": PERMISSIONS.MENU_ACCESS_VENDORS,
  "/merchants/inventory/vendors/add": PERMISSIONS.MENU_ADD_VENDOR,
  "/merchants/inventory/vendors/edit-vendor/:code": PERMISSIONS.MENU_EDIT_VENDOR,
  // "/merchants/inventory/vendors/vendor-details/:code": PERMISSIONS.MENU_ACCESS_VENDORS,
  "/merchants/inventory/vendors/vendor-details/:code": PERMISSIONS.MENU_EDIT_VENDOR,

  //Employee Management
  "/merchants/employee/manage-employees": PERMISSIONS.MENU_MANAGE_EMPLOYEES,

  // Timesheet — old /timesheet is superadmin only (see LeftSide.js)
  // "/merchants/timesheet": PERMISSIONS.MENU_TIMESHEET,

  // Taxes 
  "/merchants/taxes": PERMISSIONS.MENU_ACCESS_TAXES,

  // Store Settings 
  "/merchants/store-settings/info": PERMISSIONS.MENU_STORE_INFO,
  "/merchants/store-settings/setup": PERMISSIONS.MENU_ONLINE_STORE_SETUP,
  "/merchants/store-settings/options": PERMISSIONS.MENU_STORE_OPTIONS,
  "/merchants/store-settings/Alters": PERMISSIONS.MENU_ALERTS,
  "/merchants/store-settings/inventory": PERMISSIONS.MENU_INVENTORY_SETTINGS,
  "/merchants/store-settings/system-access": PERMISSIONS.MENU_REPORTING_TIME,
  "/merchants/store-settings/register": PERMISSIONS.MENU_REGISTER_SETTINGS,
  "/merchants/web-register": PERMISSIONS.MENU_WEB_REGISTER,
  "/merchants/store-settings/breaks-and-compliance": PERMISSIONS.ACCESS_BREAKS_AND_COMPLIANCE,
  "/merchants/customer-management/customer-groups": PERMISSIONS.MENU_ACCESS_GROUP_MANAGEMENT,
  "/merchants/customer-management/create-group": PERMISSIONS.GROUP_MANAGEMENT_CREATE,
  "/merchants/customer-management/edit-group": PERMISSIONS.GROUP_MANAGEMENT_EDIT,

  // Customer Feed — posts, notifications and the follower list are one screen
  // behind one code. `/customer-feed` with no section falls through to Posts,
  // so both the bare path and the section pattern have to be listed or a typed
  // URL walks straight in.
  "/merchants/customer-feed": PERMISSIONS.ACCESS_CUSTOMER_FEED,
  "/merchants/customer-feed/:selectedSection": PERMISSIONS.ACCESS_CUSTOMER_FEED,

  // Gift Card (Android More → Gift Card: GC). Add / Remove balance check GB / RB on the page.
  "/merchants/promotions/gift-card": PERMISSIONS.MENU_GIFT_CARD,
  "/merchants/promotions/gift-card/:giftCardId": PERMISSIONS.MENU_GIFT_CARD,

}